"use client";

import { useTenant } from "@tillix/tenants/react";
import {
  BaseRadioGroup,
  type BaseRadioGroupProps,
  BaseRadio as Radio,
} from "./radio-group";

export { Radio };

export function RadioGroup(props: BaseRadioGroupProps) {
  const contextTenant = useTenant();

  const tenantRefId = props.tenant ?? contextTenant?.id;

  switch (tenantRefId) {
    default:
      return <BaseRadioGroup {...props} />;
  }
}
